import { render } from "./HighlightScreen.vue?vue&type=template&id=0cfca110&scoped=true"
import script from "./HighlightScreen.vue?vue&type=script&lang=js"
export * from "./HighlightScreen.vue?vue&type=script&lang=js"

import "./HighlightScreen.vue?vue&type=style&index=0&id=0cfca110&scoped=true&lang=css"

import exportComponent from "/tmp/build_642e477e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cfca110"]])

export default __exports__